module.exports = global["$"] = require("-!/Users/grayson/projects/MyJob/Growcn_Sites/dlj_bz/node_modules/babel-loader/lib/index.js??ref--10-0!./jquery.js");